import { useEffect, useRef } from 'react';
import { mapControls, initControls, resize_map } from "Components/Atoms/A_Reusable/ControlsMap";
import info_activate from "assets/icons/EQViewer/Icons/Active/act_botones-iconos-05.svg";
import info_off from "assets/icons/EQViewer/Icons/Normal/botones-iconos-05.svg";
import settingsIconA from "assets/icons/EQViewer/Icons/Active/settingsA.svg";
import notificationsA from "assets/icons/EQViewer/Icons/Active/notificationsA.svg";
import mapIconA from "assets/icons/Reusable/colombia_mapa_1.svg";
import listA from "assets/icons/EQViewer/Icons/Active/listA.svg";
import logo_sgc from "assets/icons/Reusable/logoWhite.svg";
import { connect } from "react-redux";
import { setVisibleNotifications } from "../../../state/actionsCreators";
import SgcServices from 'Components/Molecules/M_Reusable/SgcServices';
import services_sgc from 'assets/icons/Reusable/Viewer_services/services_sgc_on.svg';
import accessibility from 'assets/icons/EQViewer/Icons/accesibilidad_verde.svg';
import { loadNetworksData } from '../../../state/actionsCreators';
import { reqResApi } from 'api/reqRes';
import { SGCPopup } from 'Components/Atoms/A_EQDetails/SGCPopup';
import { AccessibilityTemplate } from 'Components/Molecules/M_Reusable/AccessibilityTemplate';
import { Link } from "react-router-dom";
import SgcBadge from 'Components/UI/SgcBadge';

const handleInfo = () => {
	const info_button = document.querySelector('#info_button img');
	if (info_button.style.color === 'rgb(255, 255, 255)') {
		info_button.src = info_activate;
		info_button.style.color = "#3D4E00";
	}
	else {
		info_button.src = info_off;
		info_button.style.color = "#ffffff"
	}
}

const RenderMap = (
	{
		visibleNotifications, setVisibleNotifications,
		event_list, map, settings, footer,
		modes, list_selected, map_selected,
		notificationsPanel, loadNetworksData,
		notifications, catalogMode, moduleLinks, queryView
	}
) => {

	const widthRef = useRef(window.innerWidth);

	const loadInitialData = async () => {
		try {
			const { data } = await reqResApi.get(
				'feed/v1.0/stations/stations.json'
			);
			data && loadNetworksData(data);
		} catch (err) {
			console.log(err.message);
		}

	}

	const clickEvent = ({ target }) => {
		target.id !== 'btnNotifications'
			&& target.id !== 'notificationsDiv'
			&& setVisibleNotifications(false);
	}

	const resizeEvent = () => {
		const width = window.innerWidth;
		if (widthRef.current !== width) {
			widthRef.current = width;
			resize_map();
		}
	}

	const loadWindowEvents = () => {
		window.addEventListener('resize', resizeEvent);
		document.addEventListener('click', clickEvent);
	}

	useEffect(() => {
		widthRef.current = window.innerWidth;
		initControls("view-modes");
		resize_map();
		loadWindowEvents();
		loadInitialData();
		return () => {
			document.removeEventListener('click', clickEvent);
			window.removeEventListener('resize', resize_map);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div id="ui-viewer-container" className="ui-viewer-container">

			<header className="container-header" >
				<div className="viewer-header">
					<div className="sgc-logo" >
						<Link to="/" className="logo">
							<img src={logo_sgc} alt="SGC" />
						</Link>
					</div>
					<div className="earthquakes-modes-view">
						<ul className="modes-view-container no-style" id="icon-list">
							{catalogMode && moduleLinks}
							<li
								className="modes-view-item"
								data-id="accessibility"
								title="Accesibilidad"
							>
								<span
									id="accessibility_icon"
									className="icon_display"
								>
									<img
										src={accessibility}
										alt="accesibilidad"
									/>
								</span>
								<SGCPopup
									Component={<AccessibilityTemplate />}
									id="accesibility_services"
									styles={{ top: "100%" }}
									trigger={
										{
											id: 'accessibility_icon',
											classes: 'Services_icon_on'
										}
									}
								/>
							</li>
							<li
								className={list_selected}
								onClick={() => mapControls('list')}
								id="list"
								data-id="list"
								title='Ver lista'
							>
								<img
									className="button-header"
									src={listA}
									alt="button-header"
								/>
							</li>
							<li
								className={`${map_selected} map_icon_access`}
								onClick={() => mapControls('map')}
								id="map"
								data-id="map"
								title='Ver mapa'
							>
								<img
									className="button-header"
									src={mapIconA}
									alt="button-map"
								/>
							</li>
							<li
								className="modes-view-item"
								onClick={() => mapControls('settings')}
								id="settings"
								data-id="settings"
								title='Ajustes'
								style={{ display: !catalogMode ? 'block' : 'none' }}
							>
								<img
									className="button-header"
									src={settingsIconA}
									alt="button-settings"
								/>
							</li>
							{
								!catalogMode && (
									<>
										<li
											className="modes-view-item"
											id="services_container"
											data-id="services_container"
											title='Servicios'
										>
											<span id="MapservicesCrt" >
                                    <img
                                       className="button-header"
                                       id="services_icon"
                                       src={services_sgc}
                                       alt="button-services"
                                    />

											</span>
											<SGCPopup
												Component={<SgcServices />}
												id="MapServices"
												styles={{ "top": "100%" }}
												trigger={{
													id: 'MapservicesCrt',
													classes: 'Services_icon_on'
												}}
											/>
										</li>
										<li
											className="modes-view-item"
											onClick={() => setVisibleNotifications(!visibleNotifications)}
											id="ViNotifications"
											data-id="notifications"
											title='Notificaciones'
										>
											<SgcBadge 
												badgeContent={notifications ? notifications.length : 0}
											>
												<img
													id="btnNotifications"
													className="button-header"
													src={notificationsA} alt="button-notifications"
													style={{
														filter: visibleNotifications === false
															? "" : "invert(1) sepia(1) hue-rotate(0deg) saturate(0%)"
													}}
												/>
											</SgcBadge>
										</li>

									</>
								)
							}
							<li
								className="modes-view-item"
								data-id="info"
								id="info_button"
								onClick={handleInfo}
							>
							</li>
						</ul>
					</div>
				</div>
			</header>
			<main
				id="view-modes"
				className={modes}
				onClick={
					() => setVisibleNotifications(false)
				}
			>
				<div className="events-list">
					{event_list}
				</div>
				<div className="map">
					{map}
				</div>
				<div className="settings">
					{settings}
				</div>
				<div
					id="notificationsDiv"
					className="notifications"
					style={{
						display: visibleNotifications === false
							? "none" : "block"
					}}
				>
					{notificationsPanel}
				</div>
			</main>
			<footer
				className="footer"
				onClick={
					() => setVisibleNotifications(false)
				}
			>
				{footer}
			</footer>
		</div>
	)
}

const mapStateToProps = ({ visibleNotifications, notifications }) => ({
	visibleNotifications, notifications
});

const mapDispatchToProps = { setVisibleNotifications, loadNetworksData }

export default connect(mapStateToProps, mapDispatchToProps)(RenderMap);
